export default __webpack_public_path__ + "static/media/discuss.927e2b2a.gif";